import "./LayoutCommon.scss";
import { childClassClosure } from "@Functions";

export const baseClass = 'layout-common';
export const childClass = childClassClosure(baseClass);
